/**
 * * Notificaton component to show the users the announcements .
 * @param {string} call - specify the location to be called (labs, streams, cert, home)
 */
import Styles from './notification.module.scss'
import CampaignIcon from '@mui/icons-material/Campaign';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { ViewContext, useAPI } from 'components/lib';
import { useEffect, useContext } from 'react';
import { AuthContext } from 'components/lib';
import { useState } from 'react';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Tooltip from '@mui/material/Tooltip';

export function Notification({ call }) {
    const context = useContext(AuthContext)
    const viewContext = useContext(ViewContext)
    // FIXME this is wrong
    const permission = 
        context?.permission['notification.view']
        ? "enterprise"
        : "scholar";

    const data = useAPI(call === 'all' ? `/api/notification?active=true&permission=${permission}` : `/api/notification?location=${call}&active=true&permission=${permission}`)
    const [currentIndex, setCurrentIndex] = useState(0);
    const [notif, setNotif] = useState([])

    useEffect(() => {
        if (data?.data) {
            setNotif(data?.data)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data?.data])

    useEffect(() => {
        const loopData = () => {
            if (notif && notif?.length > 0) {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % notif?.length);
            }
            setTimeout(loopData, 7500);

        };
        loopData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notif]);



    let backgroundColor;
    let color;
    switch (currentIndex) {
        case 1:
            backgroundColor = '#fce0e0';
            color = 'Maroon';
            break;
        case 2:
            backgroundColor = '#DDE5EE';
            color = 'navy'
            break;
        case 3:
            backgroundColor = '#daf7e9';
            color = 'darkgreen';
            break;
        default:
            backgroundColor = "#C6E2E9"
            color = 'blue'
            break;
    }

    const handleCopy = async () => {

        try {
            await navigator.clipboard.writeText(notif[currentIndex]?.coupon_code);
        } catch {
            alert(viewContext.t('global.notification.clipboard.alert'));
        }

    };

    const moveBack = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1)
        } else {
            setCurrentIndex(notif?.length - 1)
        }
    }
    const moveForward = () => {
        if (currentIndex >= (notif?.length - 1)) {
            setCurrentIndex(0)
        } else {
            setCurrentIndex(currentIndex + 1)
        }
    }

    return (
        (notif && notif.length > 0) &&
        <Tooltip title={notif?.coupon_code && viewContext.t('global.notification.clipboard.tooltip')} arrow followCursor>
            <div
                className={Styles.ancestorContainer}
                style={{
                    transition: '0.4s',
                    backgroundColor: backgroundColor,
                }}
            >
                {notif?.length > 1 && <KeyboardArrowLeftIcon onClick={moveBack} style={{ cursor: 'pointer', color: "black" }} />}
                {notif &&
                    <div className={Styles.mainContainer}

                    >   <div className={Styles.icon}>
                            <CampaignIcon sx={{ color: color }} className={Styles.StarLogo} />
                        </div>
                        <div className={Styles.contentContainer}>
                            <p className={Styles.message} style={{ color: 'black' }}>
                                {notif[currentIndex]?.message}
                            </p>

                        </div>
                        <div className={Styles.copyIcon}>
                            {notif[currentIndex]?.coupon_code &&
                                <>
                                    <div className={Styles.couponCode}>
                                        {notif[currentIndex]?.coupon_code}
                                    </div>

                                    < ContentCopyIcon 
                                        className={Styles.couponCopy} 
                                        sx={{ color: 'black' }} 
                                        onClick={handleCopy}
                                    />
                                </>
                            }
                        </div>
                    </div>}
                {notif?.length > 1 && 
                    <KeyboardArrowRightIcon
                        onClick={moveForward} 
                        style={{ cursor: 'pointer', color: "black" }}                                   
                    />
                }
            </div>
        </Tooltip>

    )
}